import ActionTypes from '@mdz/mirador/dist/es/src/state/actions/action-types'
import {
  getConfig,
  getManifest,
  getSearchQuery,
  getWindowConfig,
} from '@mdz/mirador/dist/es/src/state/selectors'
import { select, take, takeEvery } from 'redux-saga/effects'

import { calculatePageParamFromCanvases } from './helpers'

/** Update URL parameters whenever current page or active search or view type changes. */
function* updateUrlParams(action) {
  const { type, windowId } = action
  const { loadedManifest: initialManifestId } = (yield select(getConfig))
    ?.windows?.[0]
  const { manifestId: currentManifestId } = yield select(getWindowConfig, {
    windowId,
  })
  // This is necessary to prevent other windows not matching the ID in the URL from changing it
  if (currentManifestId !== initialManifestId) {
    return
  }

  const newParams = Object.fromEntries(new URLSearchParams(location.search))
  if (
    type === ActionTypes.SET_CANVAS ||
    type === ActionTypes.SET_WINDOW_VIEW_TYPE ||
    type === ActionTypes.SHIFT_BOOK_VIEW
  ) {
    let { visibleCanvases, view } = action
    if (
      !visibleCanvases &&
      (type === ActionTypes.SET_WINDOW_VIEW_TYPE ||
        type === ActionTypes.SHIFT_BOOK_VIEW)
    ) {
      // For view changes, get the visible canvases from the next updateWindow action
      visibleCanvases = (yield take(ActionTypes.UPDATE_WINDOW)).payload
        .visibleCanvases
    }
    const manifest = yield select(getManifest, { windowId })
    if (!manifest.json) {
      return
    }
    if (!view) {
      view = (yield select(getWindowConfig, {
        windowId,
        manifestId: manifest.id,
      })).view
    }
    const canvasIds = manifest.json.sequences[0].canvases.map(
      (canvas) => canvas['@id']
    )

    // Build page parameter
    const page = calculatePageParamFromCanvases(
      canvasIds,
      visibleCanvases,
      view
    )
    if (page) {
      newParams.page = page
    }
  } else if (type === ActionTypes.RECEIVE_SEARCH) {
    const { companionWindowId } = action
    const query = yield select(getSearchQuery, { companionWindowId, windowId })
    newParams.q = query
  } else if (type === ActionTypes.REMOVE_SEARCH) {
    delete newParams.q
  }
  const requestParams = new URLSearchParams(newParams)
    .toString()
    .replaceAll('%2C', ',')
  history.replaceState(
    { searchParams: newParams },
    '',
    `${window.location.pathname}?${requestParams}`
  )
}

/** Entry point for custom side-effects baseed on Mirador actions. */
function* rootSaga() {
  yield takeEvery(
    [
      ActionTypes.SET_CANVAS,
      ActionTypes.RECEIVE_SEARCH,
      ActionTypes.REMOVE_SEARCH,
      ActionTypes.SET_WINDOW_VIEW_TYPE,
      ActionTypes.SHIFT_BOOK_VIEW,
    ],
    updateUrlParams
  )
}

export default rootSaga
